import axios from "src/service/axios_c";
import ProductListingAPICall from "./ProductListingAPICall";
import storeInUse from "../storeWire";
import Product from "@system/config/product";
import ResponseMaker from "./ProductDetailAPICall/ProductCategory/responseMaker";
import ProductListingAPICallResponseMaker from "src/service/ProductListingAPICall/responseMaker";
import { __remove, __set } from "../store/axios_indicator";
import Auth from "@system/config/auth";
import System from "src/helper/system";
import ProductRepository from "../repository/ProductRepository";
import { isArray } from "underscore";
import Helper from "src/support/Helper";

class ProductDetailAPICall {
    async get_data_from_master_store_by_params(params) {
        let data = {};
        if (Object.entries(params).length > 0) {
            let master_data = {};
            if (storeInUse !== undefined && storeInUse) {
                let storeIn = await storeInUse.getState();
                master_data = storeIn.entities.model_ProductListing.master_data_only_products_list;
            }
            if (Object.entries(master_data).length > 0) {
                Object.entries(master_data).map((v_master_data) => {
                    Object.entries(params).map((v) => {
                        if (v_master_data[1].ERPPartNumber === v[1].ERPPartNumber) {
                            data[v[1].ERPPartNumber] = v_master_data[1];
                        }
                        if (v_master_data[1].ItemNumber === v[1].ERPPartNumber) {
                            data[v[1].ERPPartNumber] = v_master_data[1];
                        }
                    });
                });
            }
        }
        return data;
    }

    async check_ERPPartNumber_exist_in_master_data(ERPPartNumber) {
        let master_data = {};
        if (storeInUse !== undefined && storeInUse) {
            let storeIn = await storeInUse.getState();
            master_data = storeIn.entities.model_ProductListing.master_data_only_products_list;
        }
        if (master_data[ERPPartNumber] !== undefined) {
            return master_data[ERPPartNumber];
        }
        return false;
    }

    getProductDetailByItemNumber = async (ItemNumber, getOnlyFirstAndInObject = true, isProductImageInclude = false) => {
        return this.getProductDetail(ItemNumber, getOnlyFirstAndInObject, isProductImageInclude);
    };
    getProductDetail = async (ERPPartNumber, getOnlyFirstAndInObject = true, isProductImageInclude = false) => {
        let ERPPartNumber_needed_list = {};
        if (typeof ERPPartNumber === 'string' && ProductListingAPICall.validateFilterValue(ERPPartNumber)) {
            ERPPartNumber_needed_list[ERPPartNumber] = { ERPPartNumber };
        }
        if (typeof ERPPartNumber === 'object') {
            await ERPPartNumber.map(async (v) => {
                d:
                if (ProductListingAPICall.validateFilterValue(v.ERPPartNumber)) {
                    ERPPartNumber_needed_list[v.ERPPartNumber] = v;
                }
            })
        }
        let get_ERPPartNumber_needed_list = { ...ERPPartNumber_needed_list };
        if (Object.entries(ERPPartNumber_needed_list).length > 0) {
            await Promise.all(Object.entries(ERPPartNumber_needed_list).map(async (v) => {
                let fetch_flag = await this.check_ERPPartNumber_exist_in_master_data(v[0]);
                if (fetch_flag.ERPPartNumber !== undefined) {
                    delete ERPPartNumber_needed_list[v[0]];
                }
            }))
        }
        // let SboatF = !liveAuth.check() ? "T" : Auth.getAuthSBoat();
        let SboatF = Auth.getAuthSBoat();
        if (Object.entries(ERPPartNumber_needed_list).length > 0) {
            let top_count = Object.entries(ERPPartNumber_needed_list).length * 3;
            let ItemNumber_needed_list = {};
            if (Object.entries(ERPPartNumber_needed_list).length > 0) {
                await Object.entries(ERPPartNumber_needed_list).map(async (v, i) => {
                    let ERPPartNumber_here = v[0];
                    if (ProductRepository.detectStringIsItemNumber(ERPPartNumber_here)) {
                        ItemNumber_needed_list[ERPPartNumber_here] = v[1];
                        delete ERPPartNumber_needed_list[ERPPartNumber_here];
                    }
                });
            }
            let filter = "(";
            if (Object.entries(ERPPartNumber_needed_list).length > 0) {
                await Object.entries(ERPPartNumber_needed_list).map(async (v, i) => {
                    filter += (i > 0 ? " or " : "") + "ERPPartNumber eq '" + v[1].ERPPartNumber + "'";
                });
                filter = filter.trim();
            }
            if (Object.entries(ItemNumber_needed_list).length > 0) {
                if ((Object.entries(ERPPartNumber_needed_list).length > 0)) {
                    filter += " or ";
                }
                await Object.entries(ItemNumber_needed_list).map(async (v, i) => {
                    filter += (i > 0 ? " or " : "") + "ItemNumber eq '" + v[1].ERPPartNumber + "'";
                });
                filter = filter.trim();
            }
            filter += ")";
            if (filter) {
                filter += " and Sboat eq '" + SboatF + "'";
            } else {
                filter += "Sboat eq '" + SboatF + "'";
            }
            let findAndInString = filter.substring(0, 3);
            if (findAndInString === 'and') {
                filter = filter.substring(3);
            }
            // DT - 12May 11177 & 11109 - 4.On Search Call payload, isDesignsRequired should be false.  
            // let isDesignsRequired = Helper.isCallFromPDPorPLP(); // If PLP/PDP then it is true

            const config = {
                method: 'post',
                headers: Helper.getCommonHeader('POST', 'application/json'),
                data: {
                    "queryType": "simple",
                    "searchMode": "all",
                    "filter": filter.trim(),
                    "count": true,
                    "isSkipFacets": true,
                    "top": top_count,
                    // "isDesignsRequired": isDesignsRequired // 14567
                },
                ERPPartNumbers_asked_params: ERPPartNumber
            };
            await ProductListingAPICall.axiosCallToAPI(config, undefined, isProductImageInclude);
        }
        let store_res = await this.get_data_from_master_store_by_params(get_ERPPartNumber_needed_list);
        let value;
        if (getOnlyFirstAndInObject && !isArray(ERPPartNumber)) {
            value = {};
            if (store_res !== undefined && store_res[ERPPartNumber] !== undefined) {
                value = store_res[ERPPartNumber]
            }
            return {
                value: { ...value }
            }
        } else {
            value = [];
            Object.entries(store_res).map((v) => {
                value.push(v[1])
            })
            return {
                ...{
                    value
                }
            }
        }
    };
    getAlternativeProductByVariantNumber = async (ItemNum, orderBy = '', top = 10, skip = 0) => {
        const config = {
            method: 'post',
            url: Product.PRODUCT_ALTERNATIVE_DATA_LIST,
            headers: Helper.getCommonHeader('POST', 'application/json'),
            data: {
                "speedBoat": System.auth('speedBoat'),
                "ItemNum": ItemNum,
                "productResponseTypes": "CountWithData",
                "orderby": orderBy,
                "top": top,
                "skip": skip
            }
        };
        let res = {};
        await axios(config)
            .then(function (response) {
                res.data = response.data.Data;
            }).catch(() => {
            });
        let res_made = new ProductListingAPICallResponseMaker(res).process().run().get();
        return res_made;
    };

    getAlternativeProductCountByVariantNumber = async (ItemNum) => {
        const config = {
            method: 'post',
            url: Product.PRODUCT_ALTERNATIVE_DATA_LIST,
            headers: Helper.getCommonHeader('POST', 'application/json'),
            data: {
                "speedBoat": System.auth('speedBoat'),
                "ItemNum": ItemNum,
                "productResponseTypes": "CountOnly",
                "orderby": "",
                "top": 0,
                "skip": 0
            }
        };
        let res = 0;
        await axios(config)
            .then(function (response) {
                res = response.data.Data.Count;
            }).catch(() => {
            });
        // let res_made = new ProductListingAPICallResponseMaker(res).process().run().get();
        return res;
    };

    sendReportErrorEmail = async (data) => {
        __set('SEND_REPORT_ERROR_EMAIL_API_CALL')
        const config = {
            method: 'post',
            url: Product.PRODUCT_REPORT_ERROR,
            headers: Helper.getCommonHeader('POST'),
            data: data
        };
        let res = {};
        await axios(config)
            .then(function (response) {
                res = response.data;
            }).catch(() => {
                __remove('SEND_REPORT_ERROR_EMAIL_API_CALL')
            });
        __remove('SEND_REPORT_ERROR_EMAIL_API_CALL')
        return res;
    };
    getProductCategory = async () => {
        const config = {
            method: 'GET',
            url: Product.PRODUCT_CATEGORY_LIST,
            headers: Helper.getCommonHeader('GET'),
            params: {
                sboat: System.auth('speedBoat')
            }
        };
        let res = {};
        await axios(config)
            .then(function (response) {
                res = response.data.data;
            });
        return new ResponseMaker().processCategories(res);
    }

    getProductDocumentCount = async (filter) => {
        const config = {
            method: 'POST',
            url: Product.PRODUCT_DOCUMENT_LIST,
            headers: Helper.getCommonHeader('POST'),
            data: {
                "speedBoat": System.auth('speedBoat'),
                "filter": filter,
                "isIncludeCount": true,
                "orderby": "",
                "top": 0,
                "skip": 0,
                "isSkipFacets": true,
                "searchColumns": [],
                "searchType": "ProductDocuments",
                "search": "*"
            }
        };
        let res = 0;
        await axios(config)
            .then(function (response) {
                res = response.data.Data.Count;
            });
        return res;
    }

    getProductDocumentList = async (param) => {
        const config = {
            method: 'POST',
            url: Product.PRODUCT_DOCUMENT_LIST,
            headers: Helper.getCommonHeader('POST'),
            data: {
                "speedBoat": System.auth('speedBoat'),
                "filter": param.filter,
                "isIncludeCount": true,
                "orderby": param.orderby,
                "top": param.top,
                "skip": 0,
                "isSkipFacets": true,
                "searchColumns": [],
                "searchType": "ProductDocuments",
                "search": "*"
            }
        };
        let res = 0;
        await axios(config)
            .then(function (response) {
                res = response.data.Data.Documents;
            });
        return res;
    }

    getProductDocumentImageList = async (data) => {
        const config = {
            method: 'POST',
            url: Product.PRODUCT_VARIANT_ASSET_LIST,
            headers: Helper.getCommonHeader('POST'),
            data: data
        };
        let res = {};
        await axios(config)
            .then(function (response) {
                res = response.data;
            });
        return res;
    }

    getAllDesignsData = async (designArray, speedBoat) => {
        const config = {
            method: 'POST',
            url: Product.GET_DESIGN_DATA,
            headers: Helper.getCommonHeader('POST'),
            data: { designIds: [...designArray], speedboat: speedBoat },
        };
        let res = {};

        await axios(config)
            .then(function (response) {
                res = response.data;
            });
        return res;
    }

    checkIfDesignsAvailable = async (itemNumber, speedBoatName) => {
        const config = {
            method: 'GET',
            url: Product.CHECK_DESIGN_AVAILABLITY,
            params: { itemNumber, speedboat: speedBoatName },
        };

        let response = {}
        await axios(config).then((res) => {
            response = res.data;
        })

        return response;
    }

    checkDesignsExist = async (itemNumbers) => {
        const config = {
            method: 'POST',
            url: Product.CHECK_DESIGNS_EXIST,
            params: { speedboat: await Auth.getAuthSBoat() },
            headers: Helper.getCommonHeader('POST'),
            data: itemNumbers
        };

        let response = {}

        await axios(config).then((res) => {
            response = res.data;
        })

        return response;
    }

    getProductManufactureExternalSearch = async (requestUrl) => {
        const config = {
            method: 'POST',
            url: Product.PRODUCT_MANUFACTURE_EXTERNAL_SEARCH,
            headers: Helper.getCommonHeader('POST'),
            data: {
                "sBoat": System.auth('speedBoat'),
                "url": requestUrl
            }
        };
        let res = 0;
        await axios(config)
            .then(function (response) {
                res = response.data.data;
            });
        return res;
    }
}

export default ProductDetailAPICall;